import { TextAreaBoxEvidences } from './TextAreaBoxEvidences';

export default TextAreaBoxEvidences;
